/** @jsxRuntime automatic */
/** @jsxImportSource preact */
// The email panel's Send row (SPEC §19, 2026-10-03): the Send button, why it is off, and the last send error in an
// ErrorBanner right above it (the server's own sentence). Hook-free and DOM-free so tests can render it.
import { ErrorBanner } from '../components/ui';

/** The Send button with what stops it and the last send error (the server's message: a company-voice or CASL refusal,
 *  the 7-day limit, a Resend failure). */
export function SendBar(props: { why: string | null; sending: boolean; disabled: boolean; error: string | null; onSend: () => void }) {
  return (
    <div class="stack" style="gap:4px">
      <ErrorBanner error={props.error ? `Not sent: ${props.error}` : null} />
      <div class="row" style="gap:8px;flex-wrap:wrap">
        <button class="btn btn-primary" disabled={!!props.why || props.disabled} title={props.why ?? 'Sends this email now'} onClick={props.onSend}>
          {props.sending ? 'Sending…' : 'Send'}
        </button>
        {props.why ? <span class="vd-field-hint" style="max-width:360px">{props.why}</span> : null}
      </div>
    </div>
  );
}
